<template lang="html">
  <div class="teaser-list">
    <ul class="teaser-list__list">
      <TeaserItem
        v-for="item in children"
        :key="item.id"
        :item="item"
        tag="li"
      />
    </ul>
  </div>
</template>

<script>
import { sortBy } from 'lodash'
import editable from '@i22/frontend-cms-utils/mixins/editable'
import TeaserItem from 'beisheim/components/blocks/teaser-item'

export default {
  components: {
    TeaserItem
  },
  mixins: [ editable ],
  computed: {
    children () {
      if (!this.resource.children) {
        return []
      }
      return sortBy(this.resource.children, 'sort_key')
    }
  }
}
</script>

<style lang="scss">
  @import 'beisheim/scss/scale';
  @import 'beisheim/scss/breakpoints';
  @import 'beisheim/scss/grid';

  .teaser-list {
    max-width: $max-width;
    margin: 0 auto;

    @include to(2) {
      padding: scale(10) 0;
    }

    @include from(3) {
      @include grid-spacing(padding-left, 2);
      @include grid-spacing(padding-right, 2);
      padding: scale(20) 0;
    }
  }
</style>
